














































import {Component, Prop, Vue, Watch} from "vue-property-decorator";
import {Film} from "@/modules/Rhizome/interfaces/film.interface";
import LoadingSpinner from '@/components/LoadingSpinner.vue';

@Component({
  components: {
    LoadingSpinner
  }
})
export default class FilmBlock extends Vue {

  @Prop() film: Film.IFilm;
  @Prop() status: string;

  image: string = '';
  statuses = Film.FilmState;
  videoStarted: boolean = false;
  platform: string = null;
  widthPlayer: number = null;
  heightPlayer: number = null;
  aspectRatio: number = null;

  get isKiosk() {
    return this.$store.state.rhizome.kioskMode;
  }

  created() {
    this.detectOS();
  }

  mounted() {
    this.image = this.getThumbnailImage();
  }

  getThumbnailImage() {
    if (this.isKiosk) {
      return this.film.imgPreview.replace('/thumbnail/', '/medium/');
    } else {
      return this.film.imgPreview;
    }
  }

  async startPlay() {
    (this.$refs.player as any).mute();
    let startTime = this.film.loop_start ? this.film.loop_start : 60;
    (this.$refs.player as any).player.setCurrentTime(startTime);
    [this.widthPlayer, this.heightPlayer] = await Promise.all([(this.$refs.player as any).player.getVideoWidth(), (this.$refs.player as any).player.getVideoHeight()]);
    (this.$refs.player as any).play();
  }

  onThumbnailLoaded(event) {
    const { clientWidth, clientHeight } = event.target;
    this.aspectRatio = clientWidth / clientHeight;
  }

  onTimeupdate(event) {
    this.videoStarted = true;
    let startTime = this.film.loop_start ? this.film.loop_start : 60;
    let endTime = this.film.loop_end ? this.film.loop_end : 75;
    if (event.seconds < startTime || event.seconds >= endTime) {
      (this.$refs.player as any).player.setCurrentTime(startTime);
      (this.$refs.player as any).play();
    }
    (this.$refs.player as any).controls = false;
  }

  detectOS() {
    const platform = navigator.platform.toLowerCase(),
        iosPlatforms = ['iphone', 'ipad', 'ipod', 'ipod touch'];

    if (platform.includes('mac')) return this.platform = 'MacOS';
    if (iosPlatforms.includes(platform)) return this.platform = 'iOS';
    if (platform.includes('win')) return this.platform = 'Windows';
    if (/android/.test(navigator.userAgent.toLowerCase())) return this.platform =  'Android';
    if (/linux/.test(platform)) return this.platform =  'Linux';

    return this.platform = 'unknown';
  }

  @Watch('status')
  onStatusChange() {
    if (this.status === this.statuses.ACTIVE) {
      Promise.resolve()
        .then(() => {
          let img: any = new Image();
          img.addEventListener('load', e => {
            this.image = img.src;
          });
          img.src = this.film.imgLarge;
        });
    }
    else {
      this.videoStarted = false;
      this.image = this.getThumbnailImage();
    }
  }
}
